module.exports = __webpack_public_path__ + "static/media/mail_active.c312d449.svg";